import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
var FooterContainer = styled.footer(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  ", ";\n"])), function (_ref) {
  var palette = _ref.theme.palette;
  return "\n    background-color: ".concat(palette.primary.main, ";\n  ");
});
export default FooterContainer;